import React, { useState, useEffect } from 'react';
import classNames from 'classnames';
import styles from './checkbox.module.css.js';

const mapCheckedToCheckboxStatus = (checked) => checked ? 'checked' : 'unchecked';
const Checkbox = ({ name, onChange, status = 'unchecked', id, value, size = 'medium', disabled, variant = 'normal', ...rest }) => {
    const [inputState, setInputState] = useState(status);
    useEffect(() => {
        setInputState(status);
    }, [status]);
    const onChangeHandler = (event) => {
        setInputState(mapCheckedToCheckboxStatus(event.target.checked));
        if (onChange)
            onChange(id, event.target.checked);
    };
    return (React.createElement("span", { className: classNames('bc-checkbox', {
            [styles.indeterminate]: inputState === 'indeterminate',
            [styles.disabled]: disabled,
        }), "data-testid": 'checkbox' },
        React.createElement("input", { checked: inputState === 'checked', className: styles.nativeCheckbox, "data-testid": 'checkbox-input', name: name, onChange: onChangeHandler, type: 'checkbox', id: id, value: value, disabled: disabled, ...rest }),
        React.createElement("span", { className: classNames(styles.icon, 'bc-icon', {
                [styles.small]: size === 'small',
                [styles.large]: size === 'large',
                [styles.xl]: size === 'xl',
                [styles.rounded]: variant === 'rounded',
            }), "data-testid": 'checkbox-icon' })));
};

export { Checkbox, mapCheckedToCheckboxStatus };
